<script setup lang="ts">
import { ArrowRight } from '@element-plus/icons-vue'
import { useQuery } from '@tanstack/vue-query'
import { fenToYuan } from '@mp/utils'
import { IconFont, NumericalTrend } from '@mp/component'
import CountUp from 'vue-countup-v3'
import { useRouter } from 'vue-router'
import { todayOverview } from '@mp/api/mchTradeData/BpCompanyIndexDashboardController.js'
import { type Ref, computed, inject } from 'vue'

const router = useRouter()
const officeCode = inject<Ref<string>>('officeCode')

// #查询总收款
const { data: overviewData } = useQuery({
  enabled: computed(() => !!officeCode?.value),
  queryKey: ['company/index/dashboard/statement/trade/today/overview', officeCode],
  queryFn: () => todayOverview({
    officeCode: officeCode?.value,
  }),
  select: data => data?.data,
})

function handleOpenMore() {
  router.push({ name: 'StatementIndex' })
}
</script>

<template>
  <section id="DASHBOARD_TODAY" class="bg-white p-4 rounded-lg">
    <div class="flex items-center leading-none">
      <label class="text-base text-n-800 flex items-center font-medium">今日实时交易
        <p class="text-Neutral-N90 text-xs ml-2 mt-0 mb-0 leading-none">
          更新时间 {{ overviewData?.statTime }}
        </p>
      </label>

      <el-button link type="primary" class="ml-auto" @click="handleOpenMore">
        查看更多
        <el-icon>
          <ArrowRight />
        </el-icon>
      </el-button>
    </div>

    <div class="grid  grid-cols-3 gap-4 mt-6">
      <div>
        <label class="text-sm text-n-400 flex items-center">总交易额
          <el-popover
            placement="top-start" title="总交易额" :width="280" trigger="hover"
            content="消费类型的订单“支付成功”“全额退款”“部分退款”状态的订单总金额+预授权类型的订单“预授权完成成功”状态的订单总金额 -退款类型的订单“退款成功”状态的订单总金额"
          >
            <template #reference>
              <IconFont type="icon-yiwen1" class="text-n-90 ml-1" />
            </template>
          </el-popover>
        </label>
        <b class="normal-value">
          <CountUp
            v-if="overviewData?.turnover !== undefined"
            :end-val="fenToYuan(overviewData?.turnover ?? 0)"
            :options="{
              prefix: '¥',
              decimalPlaces: 2,
            }"
          />
          <span v-else>--</span>
        </b>
        <span class="text-xs text-n-90">较昨日
          <NumericalTrend :value="overviewData?.turnoverMomRate" type="up" />
        </span>
      </div>
      <div>
        <label class="text-sm text-n-400 flex items-center">总交易笔数
          <el-popover
            placement="top-start" title="总交易笔数" :width="280" trigger="hover"
            content="消费类型的订单“支付成功”“全额退款”“部分退款”状态的订单总笔数+预授权类型的订单“预授权完成成功”状态的订单总笔数 +退款类型的订单“退款成功”状态的订单总笔数"
          >
            <template #reference>
              <IconFont type="icon-yiwen1" class="text-n-90 ml-1" />
            </template>
          </el-popover>
        </label>
        <b class="normal-value">
          <CountUp
            :end-val="Number(overviewData?.tradeCount ?? 0)"
          />
        </b>
        <span class="text-xs text-n-90">较昨日
          <NumericalTrend :value="overviewData?.tradeCountMomRate" type="down" />
        </span>
      </div>
      <div>
        <label class="text-sm text-n-400 flex items-center">总手续费
          <el-popover
            placement="top-start" title="总手续费" :width="280" trigger="hover"
            content="消费类型的订单“支付成功”“全额退款”“部分退款”状态的订单的收单手续费总金额+预授权类型的订单“预授权完成成功”状态的订单的收单手续费总金额-退款类型的订单“退款成功”状态的订单退还手续费总金额"
          >
            <template #reference>
              <IconFont type="icon-yiwen1" class="text-n-90 ml-1" />
            </template>
          </el-popover>
        </label>
        <b class="normal-value">
          <CountUp
            v-if="overviewData?.acquireOrderFee !== undefined"
            :end-val="fenToYuan(overviewData?.acquireOrderFee ?? 0)"
            :options="{
              prefix: '¥',
              decimalPlaces: 2,
            }"
          />
          <span v-else>--</span>
        </b>
        <span class="text-xs text-n-90">较昨日
          <NumericalTrend :value="overviewData?.acquireOrderFeeMomRate" type="up" />
        </span>
      </div>
    </div>
  </section>
</template>

<style scoped>
.normal-value {
  @apply text-2xl text-n-800 block mb-2 mt-3 leading-none;
}
</style>
